
import { defineComponent } from "vue";
import { RANK_ICON_SVGS, RankIconSvg } from "./ranks/rankIconSvgs";

export default defineComponent({
  name: "RankIcon",
  props: {
    iconClass: { type: String, default: "" },
    extraClass: { type: String, default: "" },
  },
  computed: {
    svg(): RankIconSvg | null {
      return (this.iconClass && RANK_ICON_SVGS[this.iconClass]) || null;
    },
    fallbackClass(): string {
      // icono desconocido (rango legacy / no-rango): degradar a webfont
      return [this.iconClass, this.extraClass].filter(Boolean).join(" ");
    },
  },
});
